module.exports = __webpack_public_path__ + "img/verify3.7504fef9.png";